import * as React from 'react';

import {CONSTANT_CONTACT_EMAILS} from '../../constants';
import {FormEmails} from '../../forms';

import {StageItemSidebar} from './sidebar/stage-item-sidebar';

type OwnProps = {
    isNew: boolean;
    entityId: string | null | undefined;
    parentId: string;
};

type Props = OwnProps;

export class ConstantContactStageSubscriptionEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        return (
            <StageItemSidebar
                onSave={this.handleSidebarFormSave}
                parentId={this.props.parentId}
                title={
                    this.props.isNew
                        ? 'New Constant Contact subscription'
                        : 'Edit Constant Contact subscription'
                }
            >
                <FormEmails
                    type={CONSTANT_CONTACT_EMAILS}
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    stageId={this.props.parentId}
                    entityId={this.props.entityId}
                />
            </StageItemSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
